import { defineMessages } from "react-intl";

export const messages = defineMessages({
  preferences: {
    defaultMessage: "User preferences",
    description: "Text that describe the preferences settings image button",
    id: "UserPreferencesButton.preferences",
  },
});
